export enum DuplicateClOrdIDIndicator {
  /** Unique ClOrdID(11) */
  UniqueClOrdID = 'N',
  /** Duplicate ClOrdID(11) */
  DuplicateClOrdID = 'Y',
}
